import { Record } from 'immutable';
import ChatFilters from './ChatFilters';
const FilterKey = Record({
  filterValues: new ChatFilters(),
  sortOrder: null
}, 'FilterKey');
export default FilterKey;